
var id = "deleteIcon";
var markup = "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 240 240\" id=\"deleteIcon\">\n<style type=\"text/css\">\n\t#deleteIcon .st0{fill:#1B60AD;}\n</style>\n<g>\n\t<g>\n\t\t<defs>\n\t\t\t<path id=\"deleteIcon_SVGID_1_\" d=\"M139.44,75.56L133.89,70h-27.78l-5.56,5.56H81.11v11.11h77.78V75.56H139.44z M100.33,119.33l7.83-7.83\n\t\t\t\tL120,123.28l11.78-11.78l7.83,7.83l-11.78,11.78l11.78,11.78l-7.83,7.83L120,138.94l-11.78,11.78l-7.83-7.83l11.78-11.78\n\t\t\t\tL100.33,119.33z M86.67,158.89c0,6.11,5,11.11,11.11,11.11h44.44c6.11,0,11.11-5,11.11-11.11V92.22H86.67V158.89z\" />\n\t\t</defs>\n\t\t<use xlink:href=\"#deleteIcon_SVGID_1_\" style=\"overflow:visible;fill-rule:evenodd;clip-rule:evenodd;fill:#1B60AD;\" />\n\t\t<clipPath id=\"deleteIcon_SVGID_2_\">\n\t\t\t<use xlink:href=\"#deleteIcon_SVGID_1_\" style=\"overflow:visible;\" />\n\t\t</clipPath>\n\t</g>\n\t<path class=\"st0\" d=\"M120,20C64.77,20,20,64.77,20,120s44.77,100,100,100s100-44.77,100-100S175.23,20,120,20z M120,200\n\t\tc-44.18,0-80-35.82-80-80s35.82-80,80-80s80,35.82,80,80S164.18,200,120,200z\" />\n</g>\n</symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
